'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { ANALYTICS_SUITE_IDS, REVENUE_SUB_APP } from '../../constants/templates';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const NAV_ITEM_BADGES = {
  [ANALYTICS_SUITE_IDS.COMMERCE]: 'new',
  [REVENUE_SUB_APP]: 'beta',
  [SUB_APPS.lineItemRevenue]: 'new',
  [SUB_APPS.ticketTimeToRespond]: 'new',
  [SUB_APPS.teamActivity]: 'new',
  [SUB_APPS.ticketEnteredNew]: 'new',
  [SUB_APPS.ticketEnteredWaiting]: 'new',
  [SUB_APPS.emailRates]: 'new'
};
const AnalyticsBadge = ({
  navItemId
}) => {
  const badgeType = NAV_ITEM_BADGES[navItemId];
  if (!badgeType) {
    return null;
  }
  return /*#__PURE__*/_jsx(Badge, {
    use: badgeType,
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reports.sidebar.badges.${badgeType}`
    })
  });
};
export default AnalyticsBadge;